import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "./ui/button";
import { brand } from "../mock";

const NAV = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Airbnb", href: "/services/airbnb-turnover-cleaning", route: true },
  { label: "About", href: "#about" },
  { label: "Why Us", href: "#why-us" },
  { label: "Areas", href: "/cleaning", route: true },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-cream/95 backdrop-blur-md border-b border-[#e8d9cc]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-24 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-4">
          <img
            src="https://customer-assets.emergentagent.com/job_sterling-landing/artifacts/kxq2bn2y_The%20Sterling%20Touch%20Logo%20%289%29.png"
            alt="The Sterling Touch"
            className="w-20 h-20 object-contain"
          />
          <div className="leading-tight">
            <div className="font-brand text-base md:text-lg text-ink">
              {brand.name}
            </div>
            <div className="text-[11px] md:text-xs italic text-[#b8866e] mt-1">
              {brand.tagline}
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) =>
            n.route ? (
              <Link
                key={n.href}
                to={n.href}
                className="text-sm text-ink/80 hover:text-ink transition-colors relative group"
              >
                {n.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-sterling-dark group-hover:w-full transition-all duration-300" />
              </Link>
            ) : (
              <a
                key={n.href}
                href={n.href}
                className="text-sm text-ink/80 hover:text-ink transition-colors relative group"
              >
                {n.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-sterling-dark group-hover:w-full transition-all duration-300" />
              </a>
            )
          )}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${brand.phone.replace(/\s/g, "")}`}
            className="flex items-center gap-2 text-sm text-ink/80 hover:text-ink transition-colors"
          >
            <Phone size={14} />
            {brand.phone}
          </a>
          <a href="#quote">
            <Button className="bg-[#daae9c] hover:bg-white text-ink border border-transparent hover:border-[#daae9c] transition-colors rounded-full px-5">
              Get a Quote
            </Button>
          </a>
        </div>

        <button
          className="lg:hidden p-2 text-ink"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-cream border-t border-[#e8d9cc]">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) =>
              n.route ? (
                <Link
                  key={n.href}
                  to={n.href}
                  onClick={() => setOpen(false)}
                  className="text-ink/80 hover:text-ink text-base"
                >
                  {n.label}
                </Link>
              ) : (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="text-ink/80 hover:text-ink text-base"
                >
                  {n.label}
                </a>
              )
            )}
            <a href="#quote" onClick={() => setOpen(false)}>
              <Button className="bg-[#daae9c] hover:bg-white text-ink border border-transparent hover:border-[#daae9c] transition-colors rounded-full w-full">
                Get a Quote
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
